import styled from 'styled-components';

export const StyledCountSection = styled.div`
    position: relative;
    overflow: hidden;
    padding: 200px 0 0;

    @media(max-width: 767px){
        padding: 120px 0 0;
    }
    .counter_bottom_single {
        margin-bottom: 60px;
    }

    .text3 {
        overflow: hidden;
        span {
            display: inline-block;
        }
    }

sss

    .content_last {
        p {
            font-weight: 400;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0em; /* 0% */
            color: #152637;
            margin: 0;
        }
    }

    .count-text{
        display: flex;
        font-weight: 500;
        font-size: 7.5rem; /* 120px ÷ 16 = 7.5rem */
        line-height: 6.25rem; /* 100px ÷ 16 = 6.25rem */
        letter-spacing: -0.05em; /* -5% = -0.05em */
        color: #152637;
        position: relative;
        padding-bottom: 30px;
        margin-bottom: 30px;
        @media(max-width: 992px){
            font-size: 5.5rem; /* 120px ÷ 16 = 7.5rem */
            line-height: 5.25rem; /* 100px ÷ 16 = 6.25rem */
        }
        @media(max-width: 767px){
            font-weight: 500;
            font-size: 3.25rem;      /* 52px ÷ 16 = 3.25rem */
            line-height: 3.25rem;    /* 52px ÷ 16 = 3.25rem */
            letter-spacing: 0;
        }

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            background: #152637;
            height: 1px;
            content: "";
            bottom: 0;
        }
    }

    .second_item {
        position: relative;
        padding-bottom: 140px;

        .fixed_background {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            object-fit: cover;
            height: 100%;
            width: 100%;
            z-index: -1;
        }

        @media(max-width: 767px){
            padding-bottom: 120px;
        }
    }

    .counter_bottom {
        padding-left: ${props => props.offset ? props.offset + 'px' : '90px'};
        padding-right: ${props => props.offset ? props.offset + 'px' : '90px'};
        @media (max-width: 767px) {
            padding-left: 15px !important;
            padding-right: 15px !important;
        }
    }

    .fixed_img {
        svg, img {
            position: absolute;
            object-fit: contain;
            top: 80px;
            margin: 0 auto;
            left: -5%;
            right: -5%;
            max-width: calc(160%);
            width: 120%;
        }

        @media (max-width: 767px) {
            height: auto;
            right: 0;
            left: 0;
            top: 40px;

            svg, img {
                height: 100%;
                width: 100%;
            }
        }
    }

    .counter_left {
        h2 {
            font-size: 40px;
            font-weight: 500;
            line-height: 48px;
            color: #152637;
            @media (max-width: 767px) {
                font-size: 32px;
                line-height: 40px;
                margin-bottom: 40px;
            }
        }
    }

    .content_large {
        margin-bottom: 120px;

        h3 {
            font-weight: 500;
            font-size: 12.5rem; /* 200px ÷ 16 = 12.5rem */
            line-height: 1; /* 100% = normal line height */
            letter-spacing: 0em; /* 0% */
            color: #DD223F;
            position: relative;
            padding-bottom: 30px;
            margin-bottom: 30px;
            display: flex;
            align-items: center;

            &:after {
                position: absolute;
                left: 0;
                right: 0;
                width: 100%;
                background: #DD223F;
                height: 1px;
                content: "";
                bottom: 0;
            }

            @media(max-width: 992px){
                font-size: 8.5rem; /* 200px ÷ 16 = 12.5rem */
                line-height: 1; /* 100% = normal line height */
                letter-spacing: 0em; /* 0% */
            }
            @media(max-width: 767px){
                font-weight: 500;
                font-size: 3.25rem;      /* 52px ÷ 16 = 3.25rem */
                line-height: 3.25rem;    /* 52px ÷ 16 = 3.25rem */
                letter-spacing: 0;
            }
            p {
                font-weight: 500;
                font-size: 12.5rem; /* 200px ÷ 16 = 12.5rem */
                line-height: 1; /* 100% = normal line height */
                letter-spacing: 0em;
                color: #DD223F;
                @media(max-width: 767px){
                    font-weight: 500;
                    font-size: 3.25rem;      /* 52px ÷ 16 = 3.25rem */
                    line-height: 3.25rem;    /* 52px ÷ 16 = 3.25rem */
                    letter-spacing: 0;
                }
            }
        }

        p {
            color: #DD223F;
            font-weight: 500;
            font-size: 1.5rem; /* 24px ÷ 16 = 1.5rem */
            line-height: 1.75rem; /* 28px ÷ 16 = 1.75rem */
            letter-spacing: 0em; /* 0% */
        }

        @media (max-width: 767px) {
            margin: 0 0 40px;
            h3 {
                color: #DD223F;
                font-size: 40px;
                line-height: 40px;

                p {
                    color: #DD223F;
                    font-size: 40px;
                    line-height: 40px;
                }
            }
        }
    }

    .counter_bottom {
        .counter {
            h4 {
                font-weight: 500;
                font-size: 7.5rem; /* 120px ÷ 16 = 7.5rem */
                line-height: 6.25rem; /* 100px ÷ 16 = 6.25rem */
                letter-spacing: -0.05em; /* -5% = -0.05em */
                color: #152637;
                position: relative;
                @media(max-width: 992px){
                    font-size: 5.5rem; /* 120px ÷ 16 = 7.5rem */
                    line-height: 5.25rem; /* 100px ÷ 16 = 6.25rem */
                }
                @media(max-width: 767px){
                    font-weight: 500;
                    font-size: 3.25rem;      /* 52px ÷ 16 = 3.25rem */
                    line-height: 3.25rem;    /* 52px ÷ 16 = 3.25rem */
                    letter-spacing: 0;
                }
            }

            p {
                font-weight: 500;
                font-size: 1.5rem; /* 24px ÷ 16 = 1.5rem */
                line-height: 1.75rem; /* 28px ÷ 16 = 1.75rem */
                letter-spacing: 0;
                color: #152637;
            }
        }

        @media(max-width: 767px){
            flex-direction: column-reverse;
        }
    }
}`
